export default "__VITE_ASSET__ucIUKJeg__"